import config from 'SRC/config/config.yaml'

export const swapOptions = config.filters.swapOptions
